import { Navigate } from 'react-router-dom'

import { AppLoadingScreen } from 'src/components'
import { useSessionContext } from 'src/hooks'
import { peekConsentReturnPath } from 'src/utils/consentReturnPath'

import {
  resolveWorkspaceLanding,
  workspaceLandingPath
} from './resolveWorkspaceLanding'

/**
 * Post-login landing.
 *
 * - While the session is still loading → render the loader.
 * - 0 workspaces → the create flow.
 * - A remembered (intentionally chosen) workspace, or the only workspace →
 *   straight into its Home page.
 * - >1 workspaces and no remembered choice → the workspace selector, so the
 *   user picks instead of being dropped into the first one.
 */
export const DefaultLandingRedirect = () => {
  const { user, isLoading, storedWorkspaceId } = useSessionContext()

  if (isLoading || !user) {
    return <AppLoadingScreen />
  }

  // Signed in from an MCP consent link: finish that OAuth flow first.
  const consentReturn = peekConsentReturnPath()
  if (consentReturn) {
    return <Navigate to={consentReturn} replace />
  }

  const landing = resolveWorkspaceLanding(
    user.organizations ?? [],
    storedWorkspaceId
  )

  return (
    <>
      <AppLoadingScreen />
      <Navigate to={workspaceLandingPath(landing)} replace />
    </>
  )
}
